import { useState } from "react"
import React from "react"
import notif from "./notif.png"
import { MessageMenu, OutSideClickHandler } from "components"

// interface of Message array
interface MessageStructure {
 id: number
 date: string
 user_name: string
 user_message: string
}

// Message Array declaration
const MessagesData: MessageStructure[] = [
 {
  id: 1,
  date: "24 Jan, 2023",
  user_name: "Aktionenlog",
  user_message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
 },
 {
  id: 2,
  date: "24 Jan, 2023",
  user_name: "Aktionenlog",
  user_message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
 },
 {
  id: 3,
  date: "24 Jan, 2023",
  user_name: "Aktionenlog",
  user_message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
 },
]

export const Message: React.FC = () => {
 // state for storing message data
 const [messageData, setMessageData] = useState(() => {
  return MessagesData
 })

 // method for deleting message
 const deleteMessage = (id: number) => {
  const afterDelete = messageData.filter((single) => single.id !== id)
  setMessageData(afterDelete)
 }

 // state for messageMenu opening and closing
 const [messageMenu, setMessageMenu] = useState(false)

 // method that close the messageMenu menu on outside click
 const outSideClickHandler = () => {
  setTimeout(() => {
   setMessageMenu(false)
  }, 300)
 }

 return (
  <div className="relative">
   {/* ============= button for opening and closing of the messageMenu component */}
   <button
    onClick={() => setMessageMenu(!messageMenu)}
    className="border rounded-lg flex items-center justify-center p-1 lg:p-3"
   >
    <div className="relative">
     {/* ========= message-svg ======= */}
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
     >
      <path
       d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
       stroke="#0D0D0D"
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
      />
      <path
       d="M15.9945 11H16.0035"
       stroke="#0D0D0D"
       strokeWidth="2"
       strokeLinecap="round"
       strokeLinejoin="round"
      />
      <path
       d="M11.9945 11H12.0035"
       stroke="#0D0D0D"
       strokeWidth="2"
       strokeLinecap="round"
       strokeLinejoin="round"
      />
      <path
       d="M7.99451 11H8.00349"
       stroke="#0D0D0D"
       strokeWidth="2"
       strokeLinecap="round"
       strokeLinejoin="round"
      />
     </svg>
     {messageData.length === 0 ? (
      ""
     ) : (
      <div className="absolute right-0 top-0">
       <img className="w-2" src={notif} alt="" />
      </div>
     )}
    </div>
   </button>
   <div className="absolute z-40 lg:right-0 right-[-150px] top-20">
    {/* ============ calling-messageMenu component ================== */}
    {messageMenu && (
     <OutSideClickHandler callback={outSideClickHandler}>
      <MessageMenu deleteMessage={deleteMessage} messageData={messageData} />
     </OutSideClickHandler>
    )}
   </div>
  </div>
 )
}
